var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchRoutes.length > 0)?_c('route-tabs',_vm._l((_vm.fetchRoutes),function(route){return _c('route-tab',{key:route.pathName,attrs:{"link":{ name: route.pathName }}},[_vm._v(" "+_vm._s(route.title)+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }